module.exports = __webpack_public_path__ + "img/p-sec01-img13.6dc99375.png";